import { 
    superiorReOrgsConstants
} from "./constants"
import api from "./api"
import {
	defAction
}from "../../../helpers/defaultAction"

export const SuperiorReOrgsActions = {
    addSuperiorOrg,
    removeSuperiorOrg,
    getPotentialOrgList,
    getSuperiorOrgsPaged,
    getSuperiorOrgsList,
	clearSuperiorOrgsValues
}

function addSuperiorOrg(values){
	const dispatchObj = {
		constants : superiorReOrgsConstants.AddSuperiorOrg,
		service   : {
			func   : api.addSuperiorOrg,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function removeSuperiorOrg(values){
	const dispatchObj = {
		constants : superiorReOrgsConstants.RemoveSuperiorOrg,
		service   : {
			func   : api.removeSuperiorOrg,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getPotentialOrgList(values){
	const dispatchObj = {
		constants : superiorReOrgsConstants.GetPotentialOrgList,
		service   : {
			func   : api.getPotentialOrgList,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getSuperiorOrgsPaged(values){
	const dispatchObj = {
		constants : superiorReOrgsConstants.GetSuperiorOrgsPaged,
		service   : {
			func   : api.getSuperiorOrgsPaged,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getSuperiorOrgsList(values){
	const dispatchObj = {
		constants : superiorReOrgsConstants.GetSuperiorOrgsList,
		service   : {
			func   : api.getSuperiorOrgsList,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function clearSuperiorOrgsValues(){
	return (dispatch) => dispatch({
		type: superiorReOrgsConstants.ClearSuperiorOrgsValues
	})
}